/**
 * Portal identity service
 *
 * Who is logged in - investor contact, carry fund member, or both - and which
 * modules they may see.
 */

import type { PortalModule } from '@/types/investor';
import type { CarryProfile } from '@/portal/carry/services/carryService';
import { investorPortalApiClient } from '../utils/api-client';

export interface PortalMeContact {
  id: string;
  first_name: string;
  last_name: string;
  email: string | null;
  portal_role_id: string | null;
  portal_role_name: string | null;
  geena_available: boolean;
}

export interface PortalMeInvestor {
  id: string;
  name: string;
  investor_type: string;
}

export interface PortalMe {
  email: string;
  display_name: string;
  contact: PortalMeContact | null;
  investor: PortalMeInvestor | null;
  fund_member: CarryProfile | null;
  accessible_modules: PortalModule[];
}

export class MeService {
  static async getMe(): Promise<PortalMe> {
    return investorPortalApiClient.get<PortalMe>('/portal/me');
  }
}
